import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ErrorBoundary from './ErrorBoundary';
import './styles/fonts.css';
import './i18n';

// Add this at the top of your index.js file
window.onerror = function (message, source, lineno, colno, error) {
  if (message.toLowerCase().includes('script error')) {
    // Ignore "Script error." messages
    return true; // Suppress the error
  }
  return false; // Let other errors propagate
};

// Redirect to HTTPS in production (skip localhost/dev)
try {
  if (
    typeof window !== 'undefined' &&
    window.location &&
    window.location.protocol === 'http:' &&
    !/localhost|127\.0\.0\.1/.test(window.location.hostname)
  ) {
    window.location.replace(window.location.href.replace(/^http:/, 'https:'));
  }
} catch (e) {
  // ignore
}


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
